<template>
  <div class="header-wrapper">
      <div class="title-wrapper mx-8">
        <img :src="logo" class="logo absolute" @click="openMenu()">
        <h1 class="title text-white uppercase font-bold text-shadow text-center float-left">{{title}}</h1>
      </div>
  </div>
</template>

<script>
export default {
    props: ['title', 'company'],
    data() {
        return {

        }
    },
    computed: {
        logo() {
            if(this.company == 'web' || this.company == 'web-only')
                return require('@/assets/images/logo-web-white.svg');
            else if (this.company == 'astec')
                return require('@/assets/images/logo-astec-white.svg');
            else
                return null;
        }
    },
    methods: {
        openMenu() {
            let action;
            if(this.$store.state.menuOpen)
                action = false;
            else
                action = true;

            this.$store.commit('SET_MENU_OPEN', action);
        }
    }

}
</script>

<style lang="scss">
.header-wrapper{
    border-bottom: 2px solid rgba(white, .6);
    position: relative;
    .title-wrapper {
        .logo {
            bottom: 9px;
            height: 75px;
            &.right{
                right: 30px;
            }
        }
        .title {
            height: 75px;
            font-size: 3rem;
            width: 100%;

        }
    }
}

 //lg
@media (max-width: 1279.98px) { 
    .header-wrapper{
        .title-wrapper {
            .logo {
                &.right{
                    display: none;
                }
            }
            .title {
                font-size: 2.5rem;
            }
        }
    }
}

//md
@media (max-width: 1023.98px) {
    .header-wrapper{
        .title-wrapper {
            .logo {
                height: 50px;
                &.right{
                    display: none;
                }
            }
            .title {
                height: 60px;
                font-size: 2rem;
            }
        }
    }
}

// sm
@media (max-width: 767.98px) { 
    .header-wrapper{
        .title-wrapper {
            .logo {
                height: 40px;
            }
            .title {
                text-align: right;
                height: 45px;
                font-size: 1.5rem;
            }
        }
    }
}

// xs
@media (max-width: 639.98px) { 

}

</style>